/** Electricity tariff adjustment log /metering/fee/electricity-adjustment (electricityAdjustment.vue) */
export default {
  electricityAdjustmentPage: {
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    phStartDate: 'Start',
    phResult: 'Result',
    optAll: 'All',
    optSuccess: 'Success',
    optFail: 'Failed',
    phSerial: 'Meter serial no.',
    sectionTitle: 'Tariff adjustment log',
    selectionBefore: '',
    selectionAfter: ' row(s) selected',
    emptyTable: 'No data',
    emptyNoPermission: 'No permission to view',
    colRid: 'Record ID',
    colMeter: 'Meter (ID)',
    colSerial: 'Serial no.',
    colPricePlan: 'Plan (ID)',
    colPrices: 'Prices (S/P/F/V)',
    colTime: 'Time',
    colResult: 'Result',
    colAction: 'Actions',
    resultSuccess: 'Success',
    resultFail: 'Failed',
    resultExpired: 'Expired',
    btnDetail: 'Details',
    btnRetry: 'Retry',
    dialogDetailTitle: 'Adjustment details',
    labelOpDesc: 'Description:',
    labelRemark: 'Remark:',
    btnClose: 'Close',
    detailNoDesc: 'None',
    detailParseFail: 'Failed to parse',
    msgLoadFail: 'Failed to load data',
    msgFetchFail: 'Failed to load records',
    msgNoOperate: 'No permission',
    titleTip: 'Notice',
    btnOk: 'OK',
    btnCancel: 'Cancel',
    confirmRetry: 'Retry this price change?',
    msgRetryOk: 'Retry succeeded',
    msgOpFail: 'Operation failed',
    msgRetryFail: 'Retry failed',
    msgRetryError: 'Retry request failed',
    msgNoExport: 'Nothing to export',
    exportFileName: 'price-adjustments.xlsx',
    msgExportDev: 'Export is not available yet.',
    // Export (current page / selected / all) unified copy
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    msgNoDataExport: 'Nothing to export',
    warnNoSelectedExport: 'Please select rows to export first',
    msgExportOk: 'Exported {count} row(s)',
    msgExportOkSelected: 'Exported {count} row(s)',
    msgExportFail: 'Export failed',
    successExported: 'Exported {count} row(s)',
    successExportedLimit: '{total} matched, up to {count} per export, first {count} exported',
    exporting: 'Exporting all data...',
    exportSheetName: 'Price Adjustments',
    filePrefix: 'PriceAdjustments'
  }
}
